import React from "react";

export default function CardsLoader() {
  return (
    <div className="bg-white">
      {/* Static heading */}
      <div className="py-10">
        <h1 className="text-4xl font-segoe font-bold">Research</h1>
      </div>

      {/* Animated card grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 w-full pb-[40px] animate-pulse">
        {[...Array(4)].map((_, index) => (
          <div
            key={index}
            className="rounded-xl shadow-xl w-full min-h-[35.70rem] flex flex-col bg-white"
          >
            {/* Image placeholder */}
            <div className="flex justify-center items-center h-[19.438rem] bg-gray-200 rounded-t-lg"></div>

            {/* Text placeholders */}
            <div className="flex flex-col justify-between flex-1 px-6 pb-10">
              <div>
                <div className="h-6 w-3/4 bg-gray-200 rounded my-3"></div>
                <div className="h-4 w-full bg-gray-200 rounded my-2"></div>
                <div className="h-4 w-50 bg-gray-200 rounded my-2"></div>
                <div className="h-4 w-50 bg-gray-200 rounded my-2"></div>
              </div>
              <div className="h-5 w-24 bg-gray-300 rounded mt-4"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
